// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://harivishnu-in.onrender.com/api';

const toPathParam = (value: string | number): string => encodeURIComponent(String(value));

export const API_ENDPOINTS = {
    // Auth endpoints
    AUTH: {
        LOGIN: `${API_BASE_URL}/auth/login`,
        REGISTER: `${API_BASE_URL}/auth/register`,
        GOOGLE: `${API_BASE_URL}/auth/google`,
        CHECK_EMAIL: `${API_BASE_URL}/auth/check-email`,
    },
    
    // User endpoints
    USER: {
        PROFILE: `${API_BASE_URL}/user/profile`,
        HEARTBEAT: `${API_BASE_URL}/user/heartbeat`,
        READ_ARTICLES: `${API_BASE_URL}/user/read-articles`,
        VIEWED_ARTICLES: `${API_BASE_URL}/user/viewed-articles`,
    },
    
    // Blog endpoints
    BLOG: {
        THOUGHTS: `${API_BASE_URL}/blog-thoughts`,
        THOUGHTS_GET: (blogId: string | number) => `${API_BASE_URL}/blog-thoughts/${blogId}`,
        THOUGHTS_COUNT: (postId: string | number) => `${API_BASE_URL}/blog-thoughts/${postId}/count`,
        POSTS: `${API_BASE_URL}/blog/posts`,
        POST_BY_SLUG: (slug) => `${API_BASE_URL}/blog/posts/${encodeURIComponent(slug)}`,
        CATEGORIES: `${API_BASE_URL}/blog/categories`,
    },
    
    // Store endpoints
    STORE: {
        PRODUCTS: `${API_BASE_URL}/store/products`,
        PRODUCT: (id: string | number) => `${API_BASE_URL}/store/products/${id}`,
        PRODUCT_BY_SLUG: (slug: string | number) => `${API_BASE_URL}/store/products/slug/${toPathParam(slug)}`,
        PRODUCT_IMAGES: (slug: string | number) => `${API_BASE_URL}/store/products/slug/${toPathParam(slug)}/images`,
        PRODUCT_BY_HYGRAPH: (hygraphId: string | number) => `${API_BASE_URL}/store/products/hygraph/${hygraphId}`,
        CATEGORIES: `${API_BASE_URL}/store/categories`,
        BRANDS: `${API_BASE_URL}/store/brands`,
        COUPON: (code: string | number) => `${API_BASE_URL}/store/coupon/${toPathParam(code)}`,
        APPLICABLE_COUPONS: `${API_BASE_URL}/store/coupons/applicable`,
        PRODUCT_REVIEWS: (productId: string | number) => `${API_BASE_URL}/store-product-reviews/${productId}`,
        PRODUCT_REVIEWS_POST: `${API_BASE_URL}/store-product-reviews`,
        PRODUCT_REVIEWS_COUNT: (productId: string | number) => `${API_BASE_URL}/store-product-reviews/${productId}/count`,
        REGION_DETECT: `${API_BASE_URL}/store/region/detect`,
        REGIONS: `${API_BASE_URL}/store/regions`,
        SAVE_CONTACT_INFO: `${API_BASE_URL}/store/save-contact-info`,
        SAVE_ADDRESS_INFO: `${API_BASE_URL}/store/save-address-info`,
        SAVE_ORDER_DATA: `${API_BASE_URL}/store/save-order-data`,
        ORDERS_USER: (userId: string | number) => `${API_BASE_URL}/store/orders/user/${userId}`,
        ORDER_BY_ID: (orderId: string | number) => `${API_BASE_URL}/store/orders/${orderId}`,
        IMAGE_DOWNLOAD: (url: string, filename: string) => `${API_BASE_URL}/images/download?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename)}`,
    },
    
    // E-Products endpoints removed
    
    // Podcast endpoints
    PODCAST: {
        ALL: `${API_BASE_URL}/podcasts`,
        PROGRESS: `${API_BASE_URL}/podcasts/progress`,
        LIKE: (podcastId: string | number) => `${API_BASE_URL}/podcasts/like/${podcastId}`,
        BY_SLUG: (slug: string | number) => `${API_BASE_URL}/podcasts/slug/${slug}`,
        TRANSCRIPT: (slug: string | number) => `${API_BASE_URL}/podcasts/slug/${slug}/transcript`,
        COMMENTS: (podcastId: string | number) => `${API_BASE_URL}/podcast-comments/${podcastId}`,
        COMMENTS_POST: `${API_BASE_URL}/podcast-comments`,
        COMMENTS_COUNT: (podcastId: string | number) => `${API_BASE_URL}/podcast-comments/${podcastId}/count`,
    },
    
    // Forgot password endpoints
    FORGOT_PASSWORD: {
        CHECK_EMAIL: `${API_BASE_URL}/forgot-password/check-email`,
        REQUEST_OTP: `${API_BASE_URL}/forgot-password/request-otp`,
        VERIFY_OTP: `${API_BASE_URL}/forgot-password/verify-otp`,
    },
    
    // Newsletter endpoints
    NEWSLETTER: {
        SUBSCRIBE: `${API_BASE_URL}/newsletter/subscribe`,
    },
    
    // Promotion endpoints
    PROMOTIONS: {
        ACTIVE: `${API_BASE_URL}/promotions/active`,
    },
    
    // Payment endpoints
    PAYMENT: {
        CREATE_ORDER: `${API_BASE_URL}/payment/create-payment-order`,
        FREE_ORDER: `${API_BASE_URL}/payment/complete-free-order`,
        VERIFY: `${API_BASE_URL}/payment/verify-payment`,
        STATUS: `${API_BASE_URL}/payment/payment-status`,
    },

    // NewsRoom endpoints
    NEWSROOM: {
        CATEGORIES: `${API_BASE_URL}/newsroom/categories`,
        SOURCES:    (category: string | number) => `${API_BASE_URL}/newsroom/sources?category=${toPathParam(category)}`,
        NEWS:       (category: string | number) => `${API_BASE_URL}/newsroom/news?category=${toPathParam(category)}`,
        CHAT:       `${API_BASE_URL}/newsroom/chat`,
    },

    // Subscription endpoints
    SUBSCRIPTION: {
        PLANS: `${API_BASE_URL}/subscription/plans`,
        STATUS: `${API_BASE_URL}/subscription/status`,
        STATUS_FOR_FEATURE: (feature: string | number) => `${API_BASE_URL}/subscription/status?feature=${toPathParam(feature)}`,
        CREATE_ORDER: `${API_BASE_URL}/subscription/create-order`,
        VERIFY_PAYMENT: `${API_BASE_URL}/subscription/verify-payment`,
        CANCEL: `${API_BASE_URL}/subscription/cancel`,
        HISTORY: `${API_BASE_URL}/subscription/history`,
    },

    // Typewriting endpoints
    TYPEWRITING: {
        STATS: `${API_BASE_URL}/typewriting/stats`,
        PROGRESS: `${API_BASE_URL}/typewriting/progress`,
    },

    // KnowMe endpoints
    KNOWME: {
        PROFILE: `${API_BASE_URL}/knowme/profile`,
        LINKS: `${API_BASE_URL}/knowme/links`,
        LINK: (id: string | number) => `${API_BASE_URL}/knowme/links/${id}`,
        LINKS_REORDER: `${API_BASE_URL}/knowme/links-reorder`,
        PUBLIC: (username: string | number) => `${API_BASE_URL}/knowme/u/${toPathParam(username)}`,
        CLICK: (linkId: string | number) => `${API_BASE_URL}/knowme/click/${linkId}`,
    },

    // SEO endpoints
    SEO: {
        PROJECTS: `${API_BASE_URL}/seo/projects`,
        PROJECT: (id: string | number) => `${API_BASE_URL}/seo/projects/${id}`,
        AUDITS: `${API_BASE_URL}/seo/audits`,
        DASHBOARD: `${API_BASE_URL}/seo/dashboard`,
        ANALYZE_SITE: `${API_BASE_URL}/seo/analyze/site`,
        ANALYZE_KEYWORD: `${API_BASE_URL}/seo/analyze/keyword`,
        ANALYZE_BACKLINK: `${API_BASE_URL}/seo/analyze/backlink`,
        ANALYZE_TECHNICAL: `${API_BASE_URL}/seo/analyze/technical`,
        ANALYZE_CONTENT_BRIEF: `${API_BASE_URL}/seo/analyze/content-brief`,
        ANALYZE_COMPETITOR_GAP: `${API_BASE_URL}/seo/analyze/competitor-gap`,
        SAVE_COMPETITORS: (id: string | number) => `${API_BASE_URL}/seo/projects/${id}/competitors`,
        GET_COMPETITORS: (id: string | number) => `${API_BASE_URL}/seo/projects/${id}/competitors`,
        RANK_SNAPSHOT: `${API_BASE_URL}/seo/rank-tracker/snapshot`,
        RANK_HISTORY: `${API_BASE_URL}/seo/rank-tracker/history`,
        EXPORT_REPORT: `${API_BASE_URL}/seo/reports/export`,
        GSC_STATUS: `${API_BASE_URL}/seo/integrations/gsc/status`,
        GSC_TOP_QUERIES: `${API_BASE_URL}/seo/integrations/gsc/top-queries`,
    },

    // Habit Tracker endpoints
    HABIT_TRACKER: {
        LISTS: `${API_BASE_URL}/habit-tracker/lists`,
        LIST: (id: string | number) => `${API_BASE_URL}/habit-tracker/lists/${toPathParam(id)}`,
        HABITS: `${API_BASE_URL}/habit-tracker/habits`,
        HABIT: (id: string | number) => `${API_BASE_URL}/habit-tracker/habits/${toPathParam(id)}`,
        COMPLETIONS: `${API_BASE_URL}/habit-tracker/completions`,
        TOGGLE_COMPLETION: `${API_BASE_URL}/habit-tracker/completions/toggle`,
        STATS: (habitId: string | number) => `${API_BASE_URL}/habit-tracker/stats?habitId=${toPathParam(habitId)}`,
        TASKS: `${API_BASE_URL}/habit-tracker/tasks`,
        TASK: (id: string | number) => `${API_BASE_URL}/habit-tracker/tasks/${toPathParam(id)}`,
    },

    // Social Media endpoints
    SOCIAL_MEDIA: {
        PICTURES: `${API_BASE_URL}/social-media/pictures`,
        REELS: `${API_BASE_URL}/social-media/reels`,
        VIDEOS: `${API_BASE_URL}/social-media/videos`,
    },

    // Affiliate Products endpoints
    AFFILIATE_PRODUCTS: {
        ALL: `${API_BASE_URL}/affiliate-products`,
        BOOKS: `${API_BASE_URL}/affiliate-products/books`,
        GET_BOOK: (id: string | number) => `${API_BASE_URL}/affiliate-products/book/${id}`,
    },

    // Own Books (User's device-uploaded books)
    OWN_BOOKS: {
        ALL: `${API_BASE_URL}/own-books`,
        UPLOAD: `${API_BASE_URL}/own-books/upload`,
        GET_SINGLE: (id: string | number) => `${API_BASE_URL}/own-books/${id}`,
        DELETE: (id: string | number) => `${API_BASE_URL}/own-books/${id}`,
    },

    // Markets endpoints
    MARKETS: {
        ALL: `${API_BASE_URL}/markets`,
        HISTORY: (symbol: string | number) => `${API_BASE_URL}/markets/${toPathParam(symbol)}/history`,
        REFRESH: `${API_BASE_URL}/markets/refresh`,
    },

    // Admin endpoints
    ADMIN: {
        USERS: `${API_BASE_URL}/admin/users`,
        CONTENT_PLANNER: `${API_BASE_URL}/admin/content-planner`,
        DATABASE_OVERVIEW: `${API_BASE_URL}/admin/database`,
        DATABASE_COLLECTION: (name: string | number) => `${API_BASE_URL}/admin/database?collection=${toPathParam(name)}`,
        DATABASE_CREDDB: `${API_BASE_URL}/admin/database/creddb`,
        DATABASE_BLOGDB: `${API_BASE_URL}/admin/database/blogdb`,
        DATABASE_NEWSLETTERDB: `${API_BASE_URL}/admin/database/newsletterdb`,
        DATABASE_PODCASTDB: `${API_BASE_URL}/admin/database/podcastdb`,
        DATABASE_STOREDB: `${API_BASE_URL}/admin/database/storedb`,
        DATABASE_SPONSORSHIPDB: `${API_BASE_URL}/admin/database/sponsorshipdb`,
        DATABASE_USERTHOUGHTS: `${API_BASE_URL}/admin/database/userthoughts`,
        DATABASE_NEWSROOMDB: `${API_BASE_URL}/admin/database/newsroomdb`,
        DATABASE_LEARNWITHAI: `${API_BASE_URL}/admin/database/learnwithai`,
        DATABASE_SOCIALMEDIADB: `${API_BASE_URL}/admin/database/socialmediadb`,
        DATABASE_AFFILIATEPRODUCTSDB: `${API_BASE_URL}/admin/database/affiliateproductsdb`,
        COLLECTION_CREATE: (name: string | number) => `${API_BASE_URL}/admin/database/${toPathParam(name)}`,
        COLLECTION_GET: (name: string | number, id: string | number) => `${API_BASE_URL}/admin/database/${toPathParam(name)}/${toPathParam(id)}`,
        COLLECTION_UPDATE: (name: string | number, id: string | number) => `${API_BASE_URL}/admin/database/${toPathParam(name)}/${toPathParam(id)}`,
        COLLECTION_DELETE: (name: string | number, id: string | number) => `${API_BASE_URL}/admin/database/${toPathParam(name)}/${toPathParam(id)}`,
        SEND_NOTIFICATION: (name: string | number, id: string | number) => `${API_BASE_URL}/admin/database/${toPathParam(name)}/${toPathParam(id)}/notify`,
        PUBLISH_NOW: (name: string | number, id: string | number) => `${API_BASE_URL}/admin/publish-now/${toPathParam(name)}/${toPathParam(id)}`,
        APP_STORE_STATUS: `${API_BASE_URL}/admin/app-store-status`,
    },

    // App Store endpoints
    APP_STORE: {
        STATUS: `${API_BASE_URL}/app-store/status`,
    },

    // Brand My Laptop endpoints
    BRAND_MY_LAPTOP: {
        CURRENT: `${API_BASE_URL}/brand-my-laptop/current`,
        BOOK: `${API_BASE_URL}/brand-my-laptop/book`,
        ADMIN_CAMPAIGNS: `${API_BASE_URL}/brand-my-laptop/admin/campaigns`,
        ADMIN_CAMPAIGN_CREATE: `${API_BASE_URL}/brand-my-laptop/admin/campaign`,
        ADMIN_CAMPAIGN_UPDATE: (id: string | number) => `${API_BASE_URL}/brand-my-laptop/admin/campaign/${toPathParam(id)}`,
        ADMIN_CAMPAIGN_PROOF: (id: string | number) => `${API_BASE_URL}/brand-my-laptop/admin/campaign/${toPathParam(id)}/proof`,
        ADMIN_SLOT_RESET: (id: string | number, slotId: string | number) => `${API_BASE_URL}/brand-my-laptop/admin/campaign/${toPathParam(id)}/slot/${toPathParam(slotId)}/reset`,
        ADMIN_SLOT_STATUS: (id: string | number, slotId: string | number) => `${API_BASE_URL}/brand-my-laptop/admin/campaign/${toPathParam(id)}/slot/${toPathParam(slotId)}/status`,
        ADMIN_PACKAGES: `${API_BASE_URL}/brand-my-laptop/admin/packages`,
        ADMIN_PACKAGE_CREATE: `${API_BASE_URL}/brand-my-laptop/admin/package`,
        ADMIN_PACKAGE_UPDATE: (id: string | number) => `${API_BASE_URL}/brand-my-laptop/admin/package/${toPathParam(id)}`,
        ADMIN_PACKAGE_DELETE: (id: string | number) => `${API_BASE_URL}/brand-my-laptop/admin/package/${toPathParam(id)}`,
    },

    // My Wealth & Finance World endpoints
    MY_WEALTH: {
        PRIVATE: `${API_BASE_URL}/finance-world/private`,
        CHARACTER: `${API_BASE_URL}/finance-world/character`,
        PUBLIC_PROFILE: (username: string | number) => `${API_BASE_URL}/finance-world/profile/${toPathParam(username)}`,
    },
};


export default API_BASE_URL;

